import React, { useState } from 'react';
import { TagListWrapper } from './TagList.style-elements';
import Tag from './Tag';

interface TagsWithStatus {
  tag: string;
  status: boolean;
}

interface TagListProps {
  tags: string[];
  onChange: (tags: string[]) => void;
}

const TagList: React.FC<TagListProps> = ({ tags, onChange }) => {
  const initialTagsWithStatus: TagsWithStatus[] = tags.map((tag) => ({
    tag,
    status: false,
  }));
  const [tagsWithStatus, setTagsWithStatus] = useState<TagsWithStatus[]>(
    initialTagsWithStatus
  );

  const mapTagsWithStatus = (
    tagsArr: TagsWithStatus[],
    modifiedTag: string,
    modifiedTagStatus: boolean
  ): TagsWithStatus[] => {
    return tagsWithStatus.map(({ status, tag }) => {
      if (modifiedTag === tag) {
        return {
          tag: modifiedTag,
          status: modifiedTagStatus,
        };
      }
      return { status, tag };
    });
  };

  const handleClick = (modifiedTag: string, isSelected: boolean): void => {
    const newTagsWithStatus = mapTagsWithStatus(
      tagsWithStatus,
      modifiedTag,
      isSelected
    );
    setTagsWithStatus(newTagsWithStatus);
    onChange(
      newTagsWithStatus.filter(({ status }) => status).map(({ tag }) => tag)
    );
  };

  return (
    <>
      <TagListWrapper data-test="tag-list-wrapper">
        {tags.map((tag) => (
          <Tag
            key={tag}
            onClick={(isSelected): void => handleClick(tag, isSelected)}
            data-test="single-tag-item"
          >
            {tag}
          </Tag>
        ))}
      </TagListWrapper>
    </>
  );
};

export default TagList;
